import React from "react";
import { Form } from "react-bootstrap";
import moment from "moment";

const InputText = ({
  name,
  value,
  onChange,
  onBlur,
  disabled = false,
  placeholder = null,
  type = "text",
  min = null,
  max = null,
  step = null,
  as = "input",
  style = {},
  className,
}) => {
  const formattedValue = () => {
    if (!value) return "";
    if (value instanceof Date) {
      return moment(value).format(moment.HTML5_FMT.DATETIME_LOCAL);
    }
    return value;
  };

  const defaultValue = typeof value === "number" ? 0 : "";

  return (
    <Form.Control
      name={name}
      as={as}
      type={type}
      style={style}
      className={className}
      disabled={disabled}
      placeholder={placeholder}
      min={min}
      max={max}
      step={step}
      onBlur={onBlur}
      onChange={onChange}
      value={formattedValue() || defaultValue}
    />
  );
};

export default InputText;
